import { FC } from 'react';
import { Button, ButtonSizes, ButtonStyles, Icon, Icons } from '@silverfort/sf-components';

const INSIGHT_LIST_ITEM_SKELETON_COUNT = 6;

const TopBarItemLoading: FC<{ title: string }> = ({ title }) => {
    return (
        <div className="flex-1 p-2 rounded-[8px] flex flex-col gap-2 bg-sf-gray-0">
            <div className="flex justify-between">
                <span className="font-sf text-12">{title}</span>
                <div className="animate-pulse w-5 h-4 rounded-[4px] bg-sf-gray-100" />
            </div>
            <div className="flex gap-0.5 width w-full rounded-[2px] overflow-hidden">
                <div className="animate-pulse h-1 bg-sf-gray-50 flex-[0.85]" />
                <div className="animate-pulse h-1 bg-sf-gray-50 flex-[0.15]" />
            </div>
        </div>
    );
};

const InsightListItemLoading: FC = () => {
    return (
        <div className="group p-4 rounded-[8px] bg-sf-gray-0 flex flex-col gap-2">
            <div className="animate-pulse w-[92px] h-5 rounded-[4px] bg-sf-gray-100" />
            <div className="w-full flex flex-col justify-between gap-2">
                <div className="animate-pulse w-30 h-6 rounded-[4px] bg-sf-gray-100" />
                <div className="flex flex-col gap-1">
                    <div className="animate-pulse w-[170px] h-3 rounded-[4px] bg-sf-gray-100" />
                    <div className="animate-pulse w-[170px] h-3 rounded-[4px] bg-sf-gray-100" />
                </div>
            </div>
            <Button
                disabled
                text="Create policy"
                iconRight={Icons.ArrowForward}
                buttonStyle={ButtonStyles.Primary}
                buttonSize={ButtonSizes.Small}
            />
        </div>
    );
};

const PolicyInsightsLoading: FC = () => {
    return (
        <div className="min-w-[290px] w-[290px] h-full bg-white shadow overflow-hidden flex flex-col">
            <div className="px-4 py-2 flex gap-2 items-center border-b border-sf-gray-100">
                <div className="flex items-center gap-1">
                    <Icon icon={Icons.Lightning} className="text-sf-gray-400" />
                    <span className="font-sf text-13 font-medium">Insights</span>
                </div>
                <div className="animate-pulse w-10 h-6 rounded-[4px] bg-sf-gray-200" />
            </div>
            <div className="px-2 py-1 border-b border-sf-gray-100 flex gap-2">
                <TopBarItemLoading title="Open" />
                <TopBarItemLoading title="Resolved" />
            </div>
            <div className="p-4 flex flex-col gap-4 h-full overflow-hidden">
                {Array.from({ length: INSIGHT_LIST_ITEM_SKELETON_COUNT }, (_, i) => (
                    <InsightListItemLoading key={i} />
                ))}
            </div>
        </div>
    );
};

export default PolicyInsightsLoading;
